import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { ReleaseNote } from '../models/release-note';

/** Loads the curated, FE-owned release notes from the static asset. The single
 *  `HttpClient.get('assets/release-notes.json')` is the seam to later swap for a
 *  backend `/api/release-notes` endpoint without touching consumers. */
@Injectable({ providedIn: 'root' })
export class ReleaseNotesService {
  private releases$ = this.http
    .get<ReleaseNote[]>('assets/release-notes.json')
    .pipe(catchError(() => of([] as ReleaseNote[])), shareReplay(1));

  constructor(private http: HttpClient) {}

  getReleases(): Observable<ReleaseNote[]> {
    return this.releases$;
  }

  latestVersion(): Observable<string | null> {
    return this.getReleases().pipe(map(rs => (rs.length ? rs[0].version : null)));
  }
}
